import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetSeverityTypes(page = 1, pageSize = 10000) {
  const url = useMemo(
    () =>
      `case_severity_types` +
      makeQueryString({
        page,
        size: pageSize
      }),
    [page, pageSize]
  );
  const { loading, error, response } = useFetchGet(url);

  return {
    loading,
    error,
    severityTypes: response?.results,
    count: response?.count
  };
}
